// WhatWeDo.js
import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Briefcase } from 'lucide-react';

const WhatWeDo = () => {
  const pathways = [
    {
      icon: GraduationCap,
      title: 'Study Abroad Support',
      description: 'Students get one to one consultations, help assembling and checking an application, and someone to explain each admissions stage as it arrives.',
      color: 'blue'
    },
    {
      icon: Briefcase,
      title: 'Work Abroad Support',
      description: 'Candidates who qualify are taken through eligibility checks, prepared properly for interview, and supported while the hiring side makes its decision.',
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      purple: 'border-t-purple-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            What We Do
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-2xl mx-auto">
            Two routes sit at the centre of what Ivipass does
          </p>
        </motion.div>

        {/* Pathways Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {pathways.map((pathway, index) => {
            const Icon = pathway.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-white p-6 border-t-2 ${getColorClasses(pathway.color)} hover:shadow-lg transition-shadow`}
              >
                <Icon size={32} className="text-gray-700 mb-4" />
                
                <h3 className="text-lg font-semibold text-primary mb-3 leading-tight">
                  {pathway.title}
                </h3>
                
                <p className="text-gray-600 text-sm font-light leading-relaxed">
                  {pathway.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
